import React, { Component } from "react";

import { getRequest } from "../../../api/ApiService";
import PeerEvaluationModal from "../../../components/peer-evaluation/peer-evaluation-modal";
import PeerEvaluationFeedback from "../../../components/peer-evaluation/peer-evaluation-feedback";
import Auth from "../../../routes/Auth";
import sortBy from "lodash/sortBy";
import styled from "styled-components";

const ChartButton = styled.div`
  font-family: Lato;
  font-size: 16px;
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 0 10px;

  &:last-child {
    justify-content: flex-end;
  }
  &:first-child {
    justify-content: flex-start;
  }
`;

const ChartButtonContent = styled.div`
  display: inline-block;
  text-align: center;

  h3 {
    font-weight: bold;
    font-size: 16px;
    margin-bottom: 5px;
    color: #36507e;
  }

  span {
    color: #74abec;
    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }
  }
`;

const ucFirst = str => (str ? str[0].toUpperCase() + str.slice(1) : str);

class ChartViewMore extends Component {
  constructor(props) {
    super(props);

    const userId = parseInt(Auth.getUserId(), 10);

    this.state = {
      currentUserId: userId,
      currentTeamId: Auth.getTeamId(),
      readonlyMode: true,
      questionsOrder: [],
      isIntroScreen: true,
      isFinalScreen: false,
      isTransitionScreen: false,
      currentPage: 0,
      show: false,
      progressBar: [],
      currentId: 1,
      finalReflectionQuestions: [],
      teamList: [],
      submitPages: {},
    };
  }

  async componentDidMount() {
    const { survey } = this.props;
    const finalReflectionQuestions = survey.questions.filter(question => (
      question.category === 'communication' && question.answer_type === 'freeform'
    ));

    let progressBar = [
      ...(finalReflectionQuestions.length > 0 ? [{
        id: 1,
        title: 'Final Reflection',
        progress: 0
      }] : []),
      {
        id: finalReflectionQuestions.length > 0 ? 2 : 1,
        title: "Peer Rating",
        progress: 0
      }
    ];

    this.setState({
      progressBar,
      finalReflectionQuestions,
    }, async () => {
      await this.getTeamList();
    });
  }

  async getTeamList() {
    const { currentUserId, currentTeamId } = this.state;
    const { body: users } = await getRequest(
      `${process.env.REACT_APP_API_URL}team/players/?team=${currentTeamId}`
    );

    const teamList = sortBy(users.filter(
      teammate => teammate.role !== 'VI'
        && teammate.team === currentTeamId
        && teammate.user
        && teammate.user.id !== currentUserId
    ).map(teammate => teammate.user), "id")
      .map(teammate => {
        return {
          id: teammate.id,
          username: teammate.username,
          fullname: `${teammate.first_name} ${teammate.last_name}`
        };
      });

    this.setState({
      teamList,
    }, () => {
      this.questionsOrder();
    });
  }

  questionsOrder = () => {
    const { survey, reports, userScoreReports } = this.props;
    const { finalReflectionQuestions } = this.state;
    const questions = reports[survey.stage] ? reports[survey.stage].user_score_question || [] : [];
    const questionsOrder = [];

    if (finalReflectionQuestions.length > 0) {
      const iLikeQuestions = finalReflectionQuestions.filter(q => q.text.length >= 61 && q.text.toLowerCase().replace(/\s+/g, ' ').substr(0, 61) === 'i like: in terms of working together, what did you like about');
      const iWishQuestions = finalReflectionQuestions.filter(q => q.text.length >= 54 && q.text.toLowerCase().replace(/\s+/g, ' ').substr(0, 54) === 'i wish: in terms of working together, what do you wish');

      let usersAnswers = [];
      if (userScoreReports && userScoreReports[survey.stage] && userScoreReports[survey.stage].freeform_answers) {
        usersAnswers = userScoreReports[survey.stage].freeform_answers;
      }

      questionsOrder.push([
        { answer_type: "final_reflection_feedback_intro" },
        ...iLikeQuestions.map(q => ({
          id: q.id,
          text: q.text,
          answer_type: "ilike",
          answers: usersAnswers.filter(aa => aa.survey_question === q.id),
        })),
        ...iWishQuestions.map(q => ({
          id: q.id,
          text: q.text,
          answer_type: "iwish",
          answers: usersAnswers.filter(aa => aa.survey_question === q.id),
        })),
        { answer_type: "final_peer_rating_page" },
      ]);
    }

    let peer_rating_questions = questions.map((item, index) => (
      {
        id: index + 1,
        text: item.question,
        category: 'likert',
        answer_type: 'rating',
        value: Math.round(item.median)
      }
    ));

    peer_rating_questions = [
      { answer_type: "peer_rating_feedback_intro" },
      ...peer_rating_questions,
      { answer_type: "final_peer_rating_page" }
    ];

    questionsOrder.push(peer_rating_questions);

    this.setState(() => ({
      questionsOrder,
    }));
  };

  isIntroScreen = (nextPage, nextId) => {
    const { questionsOrder } = this.state;
    const type = questionsOrder[nextId - 1][nextPage].answer_type;

    return (
      nextId === 1 &&
      (type === "peer_rating_feedback_intro" || type === "final_reflection_feedback_intro")
    );
  };

  isFinalScreen = (nextPage, nextId) => {
    const { questionsOrder } = this.state;
    const type = questionsOrder[nextId - 1][nextPage].answer_type;

    return (
      nextId === questionsOrder.length &&
      type === "final_peer_rating_page"
    );
  }

  isTransitionScreen = (nextPage, nextId) => {
    const { questionsOrder } = this.state;
    const type = questionsOrder[nextId - 1][nextPage].answer_type;

    return type === "transition_page";
  }

  handleShowModal = () => {
    this.setState(
      () => ({ show: true }),
    );
  };

  handleHideModal = () => {
    this.setState(prevState => ({
      show: false,
      currentPage: 0,
      currentId: 1,
      isIntroScreen: true,
      isFinalScreen: false,
      isTransitionScreen: false,
      submitPages: {},
      progressBar: prevState.progressBar.map(item => ({ ...item, progress: 0 }))
    }));
  };

  goToNextPage = () => {
    const {
      currentPage,
      currentId,
      questionsOrder,
    } = this.state;

    let nextPage = currentPage + 1;
    let nextId = currentId;
    if (nextPage > questionsOrder[nextId - 1].length - 1) {
      nextPage = questionsOrder[nextId - 1].length - 1;

      if (nextId + 1 <= questionsOrder.length) {
        nextId = nextId + 1;
        nextPage = 0;
      }
    }

    const isIntroScreen = this.isIntroScreen(nextPage, nextId);
    const isFinalScreen = this.isFinalScreen(nextPage, nextId);
    const isTransitionScreen = this.isTransitionScreen(nextPage, nextId);

    this.setState(prevState => ({
      currentPage: nextPage,
      currentId: nextId,
      isIntroScreen,
      isFinalScreen,
      isTransitionScreen,
      progressBar: prevState.progressBar.map(item => item.id === nextId ? (
        {
          ...item,
          progress: Math.min((nextPage / (questionsOrder[nextId - 1].length - 1)) * 100, 100),
        }
      ) : item)
    }));
  };

  goToPrevPage = () => {
    const {
      currentPage,
      currentId,
      questionsOrder,
    } = this.state;

    let prevPage = currentPage - 1;
    let prevId = currentId;
    if (prevPage < 0) {
      prevPage = 0;

      if (prevId - 1 >= 1) {
        prevId = prevId - 1;
        prevPage = questionsOrder[prevId - 1].length - 1;
      }
    }

    const isIntroScreen = this.isIntroScreen(prevPage, prevId);
    const isFinalScreen = this.isFinalScreen(prevPage, prevId);
    const isTransitionScreen = this.isTransitionScreen(prevPage, prevId);

    this.setState(prevState => ({
      currentPage: prevPage,
      currentId: prevId,
      isIntroScreen,
      isFinalScreen,
      isTransitionScreen,
      progressBar: prevState.progressBar.map(item => item.id === prevId ? (
        {
          ...item,
          progress: Math.min((prevPage / (questionsOrder[prevId - 1].length - 1)) * 100, 100)
        }
      ) : item)
    }));
  };

  render() {
    const {
      survey
    } = this.props;

    const {
      show,
      questionsOrder,
      isIntroScreen,
      isFinalScreen,
      isTransitionScreen,
      currentPage,
      progressBar,
      teamList,
      currentId,
      currentUserId,
      submitPages,
      readonlyMode,
    } = this.state;

    const currentQuestion = questionsOrder.length > 0 ? questionsOrder[currentId - 1][currentPage] : null;
    const hasAnswer = true;

    return (
      <ChartButton>
        <ChartButtonContent>
          <h3>
            {ucFirst(survey.stage)} <br /> Feedback
          </h3>
          <span onClick={this.handleShowModal}>
            View Details &gt;
          </span>
        </ChartButtonContent>
        <PeerEvaluationModal
          surveyId={survey.id}
          show={show}
          onHide={this.handleHideModal}
          onSubmit={this.goToNextPage}
          progressBar={progressBar}
          submitButtonText={submitPages[currentPage] ? "Submit" : isIntroScreen ? "Start" : "Save & Continue"}
          currentPage={currentPage ? Number(currentPage) : 0}
          countOfPages={questionsOrder.length > 0 ? questionsOrder[currentId - 1].length : 0}
          isInstructorMode={true}
          goNext={this.goToNextPage}
          goPrev={this.goToPrevPage}
          canSubmit={hasAnswer}
          isIntroScreen={isIntroScreen}
          isFinalScreen={isFinalScreen}
          isTransitionScreen={isTransitionScreen}
          readonlyMode={readonlyMode}
          linearExtraId="_peer-review"
        >
          {!!currentQuestion && (
            <PeerEvaluationFeedback
              question={currentQuestion}
              answers={[]}
              peer_rating_count={questionsOrder.length > 0 ? questionsOrder[currentId - 1].length - 2 : 0}
              teamList={teamList}
              currentUserId={currentUserId}
              feedbacks={{}}
              readonlyMode={readonlyMode}
            />
          )}
        </PeerEvaluationModal>
      </ChartButton>
    );
  }
}

export default ChartViewMore;



// WEBPACK FOOTER //
// ./src/instructor/components/charts/chart-view-more.js